/**
 * Validates that a string has the GUID shape (8-4-4-4-12 hex), accepting any
 * version/variant.
 *
 * NOTE: We deliberately do NOT use `validate` from the `uuid` package here.
 * That helper enforces strict RFC-4122 conformance — the version nibble must be
 * 1-5 and the variant nibble must be 8/9/a/b. Our company IDs come from SQL
 * Server `uniqueidentifier` columns, whose GUIDs are not guaranteed to be
 * RFC-4122 conformant (e.g. `…-4c76-24fa-…` has variant nibble `2`). Using the
 * strict validator made such companies unreachable: the route guard rejected
 * the id and redirected back to the company list before anything loaded.
 */
const GUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const isGuid = (value: unknown): value is string =>
  typeof value === 'string' && GUID_REGEX.test(value)
